module.exports = __webpack_public_path__ + "static/media/qr-code.91c02e13.svg";